import 'css/mobile/post-list.scss';

import 'js/mobile/common/common.jquery.js';

